module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/woman-090d3fc62cc9f41c3ed0fbb71a5f4f3f.jpg";